/* ==========================================================================
   Lovelle — tank.js (Lovelle built-in bra tank, product.tank.json)
   Loaded only on that template, after bra.js (both deferred, in that order).
   bra.js already owns the packs, the per-tank <select>s, the chips it draws
   over the colour selects (data-bra-chips), the hidden size pills, the
   add-to-cart, reviews, the before/after clip and the lightbox. This adds:

   1. The colour block above the packs: one tap puts that colour on every tank
      in every pack and updates the line under the buttons; a colour with its
      own photo turns the gallery to it. Arrow keys move between colours.
   2. The size block: one row S–4XL, handed to bra.js (LovelleBraSetSize) so
      every tank in every pack follows. Nothing is preselected; until a size
      is chosen the add-to-cart and the sticky bar take the shopper to the
      size block instead of guessing.
   3. "Different colours or sizes": opens a colour + size row per tank in the
      chosen pack; turning it off puts every tank back on the chosen colour
      and size.
   4. A one-line receipt above the button ("3 linnen · L · 2× Nude, 1× Svart").
   5. The sticky bar follows the chosen pack (name + total) and adds it.
   6. The size guide dialog with its bust calculator, which can apply its
      answer.
   7. "Pick this colour" cards further down, the numbered detail photo and
      smooth in-page links under the sticky header.

   No user-facing string is written here; every word is already in the DOM.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-tk-root]');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function qs(sel, ctx) { return (ctx || document).querySelector(sel); }
  function qsa(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  function headerOffset() {
    var h = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10);
    return (isNaN(h) ? 64 : h) + 14;
  }
  function scrollToEl(el) {
    if (!el) return;
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    window.scrollTo({ top: y, behavior: reduced ? 'auto' : 'smooth' });
  }
  function flash(el) {
    if (!el) return;
    el.classList.remove('is-flash');
    void el.offsetWidth;
    el.classList.add('is-flash');
  }

  /* ---- 7: in-page links (stars under the title, "see all reviews") ---- */
  qsa('[data-tk-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var target = qs(a.getAttribute('data-tk-scroll'));
      if (!target) return;
      e.preventDefault();
      scrollToEl(target);
      if (history.replaceState) history.replaceState(null, '', a.getAttribute('data-tk-scroll'));
    });
  });

  /* ---- 7: photo with numbered details ---- */
  qsa('[data-tk-spots]').forEach(function (box) {
    var dots = qsa('[data-tk-spot]', box);
    var panels = qsa('[data-tk-spot-panel]', box);
    if (!dots.length) return;
    function show(i) {
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === i); d.setAttribute('aria-pressed', n === i ? 'true' : 'false'); });
      panels.forEach(function (p, n) { p.classList.toggle('is-active', n === i); });
    }
    dots.forEach(function (d, n) { d.addEventListener('click', function () { show(n); }); });
    box.classList.add('is-ready');
  });

  /* ---- 6: size guide dialog + calculator (works on every section) ---- */
  var guide = qs('[data-tk-guide]');
  var lastOpener = null;
  function openGuide(opener) {
    if (!guide) return;
    lastOpener = opener || null;
    if (typeof guide.showModal === 'function') { if (!guide.open) guide.showModal(); }
    else guide.setAttribute('open', '');
    document.documentElement.classList.add('tk-guide-open');
  }
  function closeGuide() {
    if (!guide) return;
    guide.classList.add('is-closing');
    setTimeout(function () {
      guide.classList.remove('is-closing');
      if (typeof guide.close === 'function' && guide.open) guide.close();
      else guide.removeAttribute('open');
      document.documentElement.classList.remove('tk-guide-open');
      if (lastOpener && lastOpener.focus) lastOpener.focus({ preventScroll: true });
    }, reduced ? 0 : 200);
  }
  qsa('[data-tk-guide-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); openGuide(b); });
  });
  if (guide) {
    qsa('[data-tk-guide-close]', guide).forEach(function (b) { b.addEventListener('click', closeGuide); });
    guide.addEventListener('click', function (e) { if (e.target === guide) closeGuide(); });
    guide.addEventListener('cancel', function (e) { e.preventDefault(); closeGuide(); });
  }

  /* The chart (snippets/tank-size-chart): bust in cm, one size up included.
     under 78 S · 78–83 M · 84–90 L · 91–98 XL · 99–103 2XL · 104–108 3XL · 109+ 4XL */
  var LIMITS = [[78, 'S'], [84, 'M'], [91, 'L'], [99, 'XL'], [104, '2XL'], [109, '3XL']];
  function sizeFor(bust) {
    if (!bust || bust < 65 || bust > 150) return null;
    for (var i = 0; i < LIMITS.length; i++) if (bust < LIMITS[i][0]) return LIMITS[i][1];
    return '4XL';
  }
  qsa('[data-tk-calc]').forEach(function (form) {
    var bust = qs('[data-tk-bust]', form);
    var res = qs('[data-tk-calc-res]', form);
    var sizeEl = qs('[data-tk-calc-size]', form);
    var use = qs('[data-tk-calc-use]', form);
    var msg = qs('[data-tk-calc-msg]', form);
    var chart = form.parentNode;
    var current = null;
    function mark(s) {
      qsa('[data-tk-row]', chart).forEach(function (r) { r.classList.toggle('is-match', r.getAttribute('data-tk-row') === s); });
    }
    function run() {
      var b = parseFloat(bust.value);
      current = null;
      if (!b) {
        res.hidden = true; use.hidden = true; mark(null);
        msg.textContent = bust.value ? form.getAttribute('data-msg-empty') : '';
        msg.hidden = !msg.textContent;
        return;
      }
      var s = sizeFor(b);
      if (!s) {
        res.hidden = true; use.hidden = true; mark(null);
        msg.textContent = form.getAttribute('data-msg-out');
        msg.hidden = false;
        return;
      }
      current = s;
      msg.hidden = true;
      sizeEl.textContent = s;
      res.hidden = false;
      res.classList.remove('is-new'); void res.offsetWidth; res.classList.add('is-new');
      mark(s);
      if (window.TankSetSize) {
        use.textContent = (form.getAttribute('data-use') || '').replace('[size]', s);
        use.hidden = false;
      }
    }
    form.addEventListener('input', run);
    form.addEventListener('submit', function (e) { e.preventDefault(); run(); });
    use.addEventListener('click', function () {
      if (!current || !window.TankSetSize) return;
      window.TankSetSize(current);
      if (guide && guide.contains(form)) closeGuide();
      setTimeout(function () {
        var block = qs('[data-tk-size]');
        scrollToEl(block);
        flash(block);
      }, reduced ? 0 : 220);
    });
  });

  if (!root) return;
  var bundle = qs('[data-bra-bundle]', root);
  if (!bundle) return;

  var product = null;
  try { product = JSON.parse(qs('[data-bra-product-json]', root).textContent); } catch (e) { product = null; }
  var colourPos = parseInt(bundle.getAttribute('data-color-pos'), 10) || 0;
  var sizePos = parseInt(bundle.getAttribute('data-size-pos'), 10) || 0;

  /* ---- Sold-out colours ---- */
  var soldOut = [];
  if (product && product.variants && colourPos) {
    var anyAvailable = {};
    var all = [];
    product.variants.forEach(function (v) {
      var c = v.options[colourPos - 1];
      if (all.indexOf(c) < 0) all.push(c);
      if (v.available !== false) anyAvailable[c] = true;
    });
    all.forEach(function (c) { if (!anyAvailable[c]) soldOut.push(c); });
  }

  var selects = qsa('select[data-bra-color]', bundle);
  var sizeSelects = qsa('select[data-bra-size]', bundle);
  var block = qs('[data-tk-colour]', root);
  var swatches = block ? qsa('[data-tk-swatch]', block) : [];
  var currentEl = block ? qs('[data-tk-colour-current]', block) : null;
  var hintEl = block ? qs('[data-tk-colour-hint]', block) : null;
  var mix = qs('[data-tk-mix]', bundle);
  var globalColour = null;

  function labelOf(value) {
    var sw = swatches.filter(function (s) { return s.getAttribute('data-value') === value; })[0];
    return sw ? (sw.getAttribute('data-label') || value) : value;
  }

  /* ---- paint the chips bra.js drew, and the name beside each row ---- */
  selects.forEach(function (sel) {
    var chips = sel.parentNode.querySelector('.brachips');
    if (!chips) return;
    qsa('.brachips__opt', chips).forEach(function (btn) {
      var value = btn.getAttribute('data-value');
      var opt = Array.prototype.filter.call(sel.options, function (o) { return o.value === value; })[0];
      var dot = btn.querySelector('.brachips__dot');
      if (opt && dot && opt.getAttribute('data-hex')) dot.style.background = opt.getAttribute('data-hex');
      if (soldOut.indexOf(value) > -1) {
        btn.setAttribute('data-oos', 'true');
        btn.setAttribute('aria-disabled', 'true');
      }
    });
  });
  function paintRow(sel) {
    var pick = sel.closest('[data-bra-pick]');
    var name = pick ? pick.querySelector('[data-tk-pick-name]') : null;
    if (name) name.textContent = labelOf(sel.value);
  }
  selects.forEach(paintRow);

  /* ---- 1: the colour block ---- */
  swatches.forEach(function (sw) {
    if (soldOut.indexOf(sw.getAttribute('data-value')) > -1) {
      sw.setAttribute('data-oos', 'true');
      sw.setAttribute('aria-disabled', 'true');
    }
  });

  function paintBlock(value) {
    swatches.forEach(function (sw) {
      var on = sw.getAttribute('data-value') === value;
      sw.classList.toggle('is-active', on);
      sw.setAttribute('aria-checked', on ? 'true' : 'false');
      sw.tabIndex = on ? 0 : -1;
      if (on && hintEl) {
        hintEl.classList.remove('is-new'); void hintEl.offsetWidth;
        hintEl.textContent = sw.getAttribute('data-hint') || '';
        hintEl.classList.add('is-new');
      }
    });
    if (currentEl) currentEl.textContent = labelOf(value);
  }

  function showPhoto(value) {
    var sw = swatches.filter(function (s) { return s.getAttribute('data-value') === value; })[0];
    var pos = sw ? parseInt(sw.getAttribute('data-slide'), 10) : 0;
    if (!pos || typeof window.LovelleShowSlide !== 'function') return;
    window.LovelleShowSlide(pos - 1);
    var thumbs = qs('.brapdp__thumbs', root);
    if (thumbs && pos > 4) thumbs.classList.remove('is-collapsed');
  }

  function setAllColours(value, photo) {
    globalColour = value;
    selects.forEach(function (sel) {
      if (sel.__bra) sel.__bra.set(value, true); else sel.value = value;
      paintRow(sel);
    });
    paintBlock(value);
    if (photo) showPhoto(value);
    summary();
  }

  swatches.forEach(function (sw, i) {
    sw.addEventListener('click', function () {
      if (sw.getAttribute('data-oos') === 'true') return;
      setAllColours(sw.getAttribute('data-value'), true);
    });
    sw.addEventListener('keydown', function (e) {
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = swatches[(i + step + swatches.length) % swatches.length];
      next.focus();
      next.click();
    });
  });

  /* ---- 2: the size block ---- */
  var sizeBlock = qs('[data-tk-size]', root);
  var sizeBtns = sizeBlock ? qsa('[data-tk-size-btn]', sizeBlock) : [];
  var sizeCurrent = sizeBlock ? qs('[data-tk-size-current]', sizeBlock) : null;
  var sizeNeed = sizeBlock ? qs('[data-tk-size-need]', sizeBlock) : null;
  var size = null;

  // A size that exists in no colour at all is marked, not hidden.
  if (product && product.variants && sizePos) {
    sizeBtns.forEach(function (b) {
      var value = b.getAttribute('data-value');
      var any = product.variants.some(function (v) { return v.options[sizePos - 1] === value && v.available !== false; });
      if (!any) b.setAttribute('data-oos', '');
    });
  }

  function paintSize() {
    sizeBtns.forEach(function (b) {
      var on = b.getAttribute('data-value') === size;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-checked', on ? 'true' : 'false');
      b.tabIndex = (on || (!size && b === sizeBtns[0])) ? 0 : -1;
    });
    if (sizeCurrent) {
      sizeCurrent.textContent = size || (sizeCurrent.getAttribute('data-empty') || '');
      sizeCurrent.classList.toggle('is-empty', !size);
      if (size) { sizeCurrent.classList.remove('is-new'); void sizeCurrent.offsetWidth; sizeCurrent.classList.add('is-new'); }
    }
    if (sizeBlock) sizeBlock.classList.toggle('is-done', !!size);
    if (size && sizeNeed) sizeNeed.hidden = true;
  }

  function commitSize(value) {
    size = value;
    paintSize();
    if (mix && mix.checked) {
      // Mixing: the size above still fills every row, the rows stay open.
      sizeSelects.forEach(function (sel) { if (sel.__bra) sel.__bra.set(size, true); else sel.value = size; });
    } else if (typeof window.LovelleBraSetSize === 'function') {
      window.LovelleBraSetSize(size);
    }
    summary();
  }

  sizeBtns.forEach(function (b, i) {
    b.addEventListener('click', function () {
      if (b.hasAttribute('data-oos')) return;
      commitSize(b.getAttribute('data-value'));
    });
    b.addEventListener('keydown', function (e) {
      var step = (e.key === 'ArrowRight' || e.key === 'ArrowDown') ? 1 : (e.key === 'ArrowLeft' || e.key === 'ArrowUp') ? -1 : 0;
      if (!step) return;
      e.preventDefault();
      var next = sizeBtns[(i + step + sizeBtns.length) % sizeBtns.length];
      next.focus();
      next.click();
    });
  });
  window.TankSetSize = function (s) {
    var match = sizeBtns.filter(function (b) { return b.getAttribute('data-value').toLowerCase() === String(s).toLowerCase(); })[0];
    if (match) commitSize(match.getAttribute('data-value'));
  };

  function askForSize() {
    if (sizeNeed) sizeNeed.hidden = false;
    scrollToEl(sizeBlock);
    flash(sizeBlock);
    var first = sizeBtns.filter(function (b) { return !b.hasAttribute('data-oos'); })[0];
    if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, reduced ? 0 : 450);
  }
  var rowSizesTouched = false;
  function sizeReady() {
    if (!sizeBlock) return true;
    if (mix && mix.checked && rowSizesTouched) return true;
    return !!size;
  }

  // Before bra.js sees the click: no size yet means ask for one, not guess.
  var addBtn = qs('[data-bra-add]', bundle);
  bundle.addEventListener('click', function (e) {
    var hit = e.target && e.target.closest ? e.target.closest('[data-bra-add]') : null;
    if (!hit || sizeReady()) return;
    e.preventDefault();
    e.stopPropagation();
    askForSize();
  }, true);

  /* ---- 3: different colours or sizes ---- */
  if (mix) {
    mix.addEventListener('change', function () {
      bundle.classList.toggle('is-mixing', mix.checked);
      if (!mix.checked) {
        rowSizesTouched = false;
        if (globalColour) setAllColours(globalColour, false);
        // bra.js has put the rows back on its own last size; put them on ours.
        if (size && typeof window.LovelleBraSetSize === 'function') window.LovelleBraSetSize(size);
      } else if (size) {
        sizeSelects.forEach(function (sel) { if (sel.__bra) sel.__bra.set(size, true); else sel.value = size; });
      }
      summary();
    });
  }

  /* ---- 4: the receipt line above the button ---- */
  var summaryEl = qs('[data-tk-summary]', bundle);
  function summary() {
    if (!summaryEl) return;
    var current = qs('input[data-bra-tier]:checked', bundle);
    var box = current ? current.closest('[data-bra-tier-box]') : null;
    var picks = box ? qsa('[data-bra-pick]', box) : [];
    var n = current ? (parseInt(current.getAttribute('data-qty'), 10) || 1) : 1;
    var mixing = mix && mix.checked;
    var sizes = [], counts = {}, order = [];
    picks.forEach(function (pick) {
      var c = qs('[data-bra-color]', pick);
      var s = qs('[data-bra-size]', pick);
      var sv = mixing && rowSizesTouched && s ? s.value : size;
      if (sv && sizes.indexOf(sv) < 0) sizes.push(sv);
      if (c) {
        if (!counts[c.value]) { counts[c.value] = 0; order.push(c.value); }
        counts[c.value]++;
      }
    });
    if (!sizes.length) { summaryEl.hidden = true; return; }
    var text = (summaryEl.getAttribute('data-template') || '').replace('%n', n).replace('%s', sizes.join(', '));
    if (order.length) text += ' · ' + order.map(function (k) { return counts[k] + '× ' + labelOf(k); }).join(', ');
    summaryEl.textContent = text;
    summaryEl.hidden = false;
  }

  bundle.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('select[data-bra-color]')) { paintRow(t); summary(); return; }
    if (t.matches('select[data-bra-size]')) { rowSizesTouched = true; if (sizeNeed) sizeNeed.hidden = true; summary(); return; }
    if (t.matches('input[data-bra-tier]')) { paintSticky(t, true); bump(qs('[data-bra-total]', bundle)); summary(); }
  });

  /* ---- 5: the sticky bar ---- */
  var sticky = qs('[data-tk-sticky]', root);
  var stickyName = sticky ? qs('[data-tk-sticky-name]', sticky) : null;
  var stickyTotal = sticky ? qs('[data-tk-sticky-total]', sticky) : null;
  var stickyBuy = sticky ? qs('[data-tk-sticky-buy]', sticky) : null;

  function bump(el) {
    if (!el || reduced) return;
    var host = el.closest('.brabundle__add') || el;
    host.classList.remove('is-bump');
    void host.offsetWidth;
    host.classList.add('is-bump');
  }
  function paintSticky(input, animate) {
    if (!input) return;
    if (stickyName) stickyName.textContent = input.getAttribute('data-name') || stickyName.textContent;
    if (stickyTotal) {
      stickyTotal.textContent = input.getAttribute('data-total') || stickyTotal.textContent;
      if (animate) bump(stickyTotal);
    }
  }
  paintSticky(qs('input[data-bra-tier]:checked', bundle), false);

  if (stickyBuy) {
    stickyBuy.addEventListener('click', function () {
      if (!sizeReady()) { askForSize(); return; }
      if (addBtn) addBtn.click();
    });
  }

  /* ---- 7: "pick this colour" cards ---- */
  qsa('[data-tk-pick-colour]').forEach(function (b) {
    b.addEventListener('click', function () {
      var value = b.getAttribute('data-value');
      if (!value) return;
      if (mix && mix.checked) { mix.checked = false; mix.dispatchEvent(new Event('change', { bubbles: true })); }
      setAllColours(value, true);
      scrollToEl(block || bundle);
      flash(block);
    });
  });

  // Start on the preselected colour, or the first one that can be bought.
  if (swatches.length) {
    var start = (swatches.filter(function (s) { return s.classList.contains('is-active'); })[0] || swatches[0]);
    if (start.getAttribute('data-oos') === 'true') {
      start = swatches.filter(function (s) { return s.getAttribute('data-oos') !== 'true'; })[0] || start;
    }
    setAllColours(start.getAttribute('data-value'), false);
  }
  paintSize();
})();
